export const texts = {
    actions: {
        tryAgain: 'Újra',
        nextLesson: 'Következő lecke',
        nextStep: 'Következő gyakorlat',
        replayFaster: 'Gyorsabban',
        replaySlower: 'Lassabban',
        exit: 'Kilépés',
        goToCourses: 'Kurzusok',
        settings: 'Beállítom',
        play: 'Elkezdem',
        preview: 'Megnézem',
        stop: 'Leállítom',
        restart: 'Újrakezdem',
    },
    labels: {
        evaluation: {
            dialogTitle: 'Értékelés'
        },
        control: {
            useTheKeyboard: 'használd a gombokat'
        },
        category: {
            late: 'késő',
            missed: 'kihagyott',
            skipped: 'átugrott',
            unexpected: 'hibás',
            accurate: 'pontos',
            early: 'korai'
        },
        categorySummary: 'Ütéselemzés'
    },
    messages: {
        evaluationSummary: {
            passed: 'Gratulálunk!',
            failed: 'Sajnos nem sikerült',
            nextLesson: 'Folytasd a következő leckével!',
            nextStep: 'Folytasd a következő gyakorlattal!',
            goToCourses: 'Válassz egy új kurzust!',
            tryAgain: 'Játszd el még egyszer!',
        },
        evaluationDetails: (score, maxScore) => `Ez most <span class='score'>${score}</span><span class="maxScore">/${maxScore}</span> lett!`
    }
};
//# sourceMappingURL=intl.js.map